export default () => {
  return `
    * {
      box-sizing: border-box;
    }
    *:before,
    *:after {
      box-sizing: border-box;
    }
  `;
};
